module.exports = __webpack_public_path__ + "static/media/repair.e1b9bdce.svg";